import moment from "moment/moment";
import { useState, useEffect, useReducer } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import $, { data } from "jquery";
import DataTable from "datatables.net";
import { MainArea, MainAreaHeader, MainAreaBody } from "../../../layout/MainArea";
import { getDataTableDom, requestToServer } from "../../../utils/appUtils";
import TableDT from "../../../UI/TableDT";
import CardHeaderDashboardOnOff from "../../../utils/cardHeaderDashboardOnOff";
// import { reducerModalWindow } from "./ModalMfS";
import { reducerModalWindow, ModalMfS } from "./ModalMfS";
import { GetInfoMC, PostControlMC } from "../../../../api";
import { TabView, TabPanel } from 'primereact/tabview';
import { Modal } from 'react-bootstrap';
import { useAsyncEffect } from "../../../UI/useAsyncEffect";

const ROUTE_URL = "/get_conn_mc";

function MfuncStations(props) {
    clearInterval(window.timer)
    const token = localStorage.getItem('token')
    const [serverData, setServerData] = useState(null);
    const { showErrorPage, messageBox } = useOutletContext();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState(3);
    const [date, setDate] = useState();
    const [loadingStatus, setLoadingStatus] = useState(true)
    const [onoff, setOnoff] = useState(props.butchState);
    const [paramsModalWindow, dispatchModalWindow] = useReducer(reducerModalWindow, { show: false});
    const [activeIndex, setActiveIndex] = useState(0)
    const [showParrot, setShowParrot] = useState(false)
    const [inputParrot, setInputParrot] = useState(0)
    const [currentPage, setCurrentPage] = useState(1);
    const [arrTable, setArrTable] = useState([])



    let services = [
        { id: 0, name: "Доступность ККС", status: status, date: date, href: 'msdata' },
    ];

    const handleModal = (id) => {
        dispatchModalWindow({ type: 'def', id: id });
    };

    useAsyncEffect( async () => {
               window.timer = setInterval(async () => {
                let arr = []
                for(let i = 1; i < 5; i++) {
                   await GetInfoMC(token, ROUTE_URL, i, 0, 1).then((e) => {
                        arr.push(e.data.data[0])
                    })
                }        
                setArrTable(arr)   
                            }, 30000);
      }, [])

    const handleClick = async (event) => {
        if (loading) return;
        event && event.preventDefault();
        event && event.target.blur();
        // setLoading(true);
        let arr = []
        for(let i = 1; i < 5; i++) {
           await GetInfoMC(token, ROUTE_URL, i, 0, 1).then((e) => {
                arr.push(e.data.data[0])
            })
        }        
        setArrTable(arr)   
        setTimeout(() => {
            setLoading(false);
        }, 1000);
    }

    useEffect(() => {
        requestToServer(ROUTE_URL + "?crud", { method: 'GET' }, setServerData, showErrorPage, true);
        handleClick()
    }, []);

    const handleCloseModalWindow = (result) => {
        if (result.modalResult === 'mrOk') dtTable.Api.ajax.reload(null, false);
        dispatchModalWindow({ type: 'destroy' });
    };


    let styleCard = {};
    let classCard = "card h-100";
    if (props.dashboard === false) {
        styleCard = { minHeight: "var(--clientheight)" };
        classCard = "card border-0";
    }

    const handleCloseParrot = (event) => {
        setShowParrot(false);
        setInputParrot(0);
    }
    const handleBlur = () => {
        // При потере фокуса устанавливаем 0 если поле пустое
        if (inputParrot === '') {
            setInputParrot(0);
        }
    };

       const handleAcceptParrot = (id) => {
            setLoading(true);
            for(let i = 0; i < 5; i++) {
                let forSend = { boost_signal: 1, signal_value: inputParrot }
                PostControlMC(token, i, forSend)
            }
            setLoading(false);
            setShowParrot(false);
            setInputParrot(0);
            handleClick()
        }
    const clickReboot = (id) => {
            setLoading(true);
            let forSend = { reboot: 1 }
            PostControlMC(token, id, forSend).then((e) => {
                setLoading(false);
            })
        }
    
    
        const clickReset = (id) => {
            setLoading(true);
            for(let i = 0; i < 5; i++) {
                let forSend = { reset: 1 }
                PostControlMC(token, i, forSend).then((e) => {
                    setLoading(false);
                })
            }
        }
    
        const clickDisableTransmitter = (id) => {
            setLoading(true);
            for(let i = 0; i < 5; i++) {
                let forSend = { disable_transmitter: 1 }
                PostControlMC(token, i, forSend).then((e) => {
                    setLoading(false);
                })
            }
        }
        const handleChange = (e) => {
            const inputValue = e.target.value;
            
            // Разрешаем пустую строку для UX
            if (inputValue === '') {
                setInputParrot('');
              return;
            }
            
            const numValue = parseInt(inputValue, 10);
            
            // Проверяем диапазон
            if (!isNaN(numValue)) {
              if (numValue < 0) {
                setInputParrot(0);
              } else if (numValue > 4095) {
                setInputParrot(4095);
              } else {
                setInputParrot(numValue);
              }
            }
        };

    if (serverData === null)
        return <MainArea loading />;

    return (
        <>
            <MainArea>
                    <div className={classCard} style={styleCard}>
                        <MainAreaHeader caption="ККС" />
                            {services.map((e, i) => {
                                return (
                                    <div key={i} className="container-fluid padding-f-d dashboard">

                                        <fieldset className="mfuncbutton-fieldset padding-f">
                                            {loading ? (<div className="spinner-border spinner-border-sm text-primary mfuncbutton-spinner"></div>) : <div className="cont-mfuncbuttons">
                                                {
                                                    <div className='cont-mfuncbutton'><button type="button" className="btn btn-primary btn-sm btn-our mfuncbutton" onClick={() => clickReboot(i) } >Перезапуск аппаратных средств</button></div>
                                                }
                                                {
                                                    <div className='cont-mfuncbutton'><button type="button" className="btn btn-primary btn-sm btn-our mfuncbutton" onClick={() => clickReset(i)} >Сброс параметров по умолчанию</button></div>
                                                }
                                                {
                                                    <div className='cont-mfuncbutton'><button type="button" className="btn btn-primary btn-sm btn-our mfuncbutton" onClick={() => clickDisableTransmitter(i)} >Отключить радиоизлучение всех МС (установка мощности на 0)</button></div>
                                                }
                                                {
                                                    <div className='cont-mfuncbutton'><button type="button" className="btn btn-primary btn-sm btn-our mfuncbutton" onClick={() => setShowParrot(true)} >Установить мощность излучения для всех МС</button></div>
                                                }
                                            </div>
                                            }
                                    <div className="lower-line">
                                  <div className="text-cont">
                                    {arrTable.length ? arrTable.map((el, i) => {
                                        return (
                                            <div key={i} className="text text-tec">{`Текущее установленное значение мощности МС ${el.ps_number}: ${el.rf_power}`}</div>
                                        )
                                    }) : <></>}
                                  </div>
                                </div>
                                         </fieldset>
                                    <Modal show={showParrot} className={`modal-parrot`} onHide={handleCloseParrot}
                                        // onExited={handleExited} centered backdrop="static" keyboard={!(loading || !loaded)}>
                                        onExited={() => setShowParrot(false)} centered backdrop="static">
                                        <Modal.Header closeButton>
                                            <Modal.Title className="h6">Усилить радиосигнал</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body className="pb1-1">
                                    {/* <fieldset disabled={loading || !loaded || !params.show}> */}
                                            <fieldset className="mfuncbutton-fieldset">
                                                <input onBlur={handleBlur} min="0" max="4095" value={inputParrot} type="number" className='input-parrot' onChange={handleChange}></input>
                                            </fieldset>
                                        </Modal.Body>
                                        <Modal.Footer>
                                            {/* <fieldset disabled={loading || !loaded || !params.show}> */}
                                            <fieldset>
                                                <div className='cont-btn'>
                                                    <button type="button" className="btn btn-secondary btn-sm btn-our ms-2" onClick={handleCloseParrot}>Закрыть</button>
                                                    <button type="button" className="btn btn-secondary btn-sm btn-our ms-2" onClick={() => handleAcceptParrot(i)}>Применить</button>
                                                </div>
                                            </fieldset>
                                        </Modal.Footer>
                                    </Modal >
                                    </div>
                                )
                            })}
                    </div>
  
                {/* </MainAreaBody> */}
            </MainArea >
            {paramsModalWindow.show && <ModalMfS params={paramsModalWindow} handleClose={handleCloseModalWindow} />}
        </>
    );
}

let dtTable = {
    Api: null,
    getTableOptions: (crud) => {
        const dtOptions = {
            ordering: true, lengthChange: true, filter: true, paging: true, info: true, processing: true,
            order: [[0, "asc"]],
            ajax: { type: "GET", url: ROUTE_URL },
            dom: getDataTableDom("lfip", 2, 1),
            columns: [
                // { orderable: false, searchable: false, data: null, className: "dt-center td-btn-action", render: DataTable.render.btnDelete(), },
                // { data: "timestamp", title: "Временная метка", render: DataTable.render.datetime(), },
                { data: "name", title: "Наименование", render: DataTable.render.text(), },
                { data: "type", title: "Тип", render: DataTable.render.text(), },
                { data: "description", title: "Описание", render: DataTable.render.text(), },
            ],
        };
        if ((crud & 1) === 0) {
            dtOptions.order = [[0, "asc"]];
            dtOptions.columns.splice(0, 1);
            dtOptions.dom = getDataTableDom("lfip", 1, 1);
        }

        return dtOptions;
    }
};

export default MfuncStations;
